import * as Preact from 'preact';
import valstore from 'valstore';
import valstoreReactBinding from '../shared/store-react';

const valstoreReact = valstoreReactBinding(Preact);

const store = valstore.create({
  alerts: {
    errors: [],
  },

  local: {
    // Site config object stored locally
    site: {},

    // Cached list of sites for account
    sites: null,

    // Local products stored
    products: [],
  },

  ui: {
    route: {
      path: location.pathname || 'account',
      params: {},
    },
    routeHistory: [], // Stack of browse history (to show back button in bar)
  },

  user: null,
});

store.connect = (Component, mapStateToProps) => valstoreReact.connect(store, Component, mapStateToProps);

export default store;
